import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resourceAdd, resourceUpdate } from '../actions/resources.actions';
import { tableChange } from '../actions/table.actions';
import { ALL_SELECT_OPTION } from '../constants/settings.constants';
import { advancedSearchFiltersSelector } from '../selectors/advanced.search.selectors';
import { tableDataSelector } from '../selectors/resources.selectors';

export const useAdvancedSearchBase = (filtersResource, dataResource, options = {}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const filters = useSelector((state) => advancedSearchFiltersSelector(state, { resource: filtersResource }));
  const { config } = useSelector((state) => tableDataSelector(state, { resource: dataResource }));

  const activeFiltersCount =
    Object.values(filters)?.filter((value) =>
      Array.isArray(value)
        ? value.length > 0 && value?.[0] !== ALL_SELECT_OPTION.value
        : !!value && value !== ALL_SELECT_OPTION.value
    )?.length ?? 0;

  const onOpen = () => {
    setIsOpen(!isOpen);
  };

  const onInput = (value, field, additionalUpdate = {}) => {
    dispatch(
      resourceUpdate(filtersResource, 'filters', {
        ...filters,
        ...additionalUpdate,
        [field]: (options?.dateFields ?? []).includes(field) ? moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD') : value
      })
    );
  };

  const onClear = () => {
    dispatch(resourceUpdate(filtersResource, 'filters', {}));
    dispatch(
      tableChange(
        dataResource,
        _.mapValues(
          {
            ..._.omit(config, options?.searchFields ?? []),
            ...(options?.defaultFiltersState ?? {}),
            page: 1
          },
          (value) => (value === ALL_SELECT_OPTION.value || value?.[0] === ALL_SELECT_OPTION.value ? undefined : value)
        )
      )
    );
  };

  const onSearch = () => {
    dispatch(
      tableChange(
        dataResource,
        _.mapValues({ ...config, ...filters, page: 1 }, (value) =>
          value === ALL_SELECT_OPTION.value || value?.[0] === ALL_SELECT_OPTION.value ? undefined : value
        )
      )
    );
  };

  useEffect(() => {
    dispatch(resourceAdd({ key: filtersResource.key }, { filters: { ...(options?.defaultFiltersState ?? {}) } }));
  }, [dispatch, filtersResource.key, options?.defaultFiltersState]);

  return {
    filters,
    activeFiltersCount,
    onInput,
    onClear: activeFiltersCount > 0 ? onClear : undefined,
    onSearch,
    onOpen,
    isOpen
  };
};
